import { DeviceStatusInfo } from "@fairfleet/geotab/types";

/** What a vehicle is currently doing, as far as the fleet knows. */
export type DeviceActivity = "unknown" | "offline" | "driving" | "stopped" | "error";

/**
 * Reads a vehicle's current activity from its status.
 *
 * "Not heard from" and "standing still" are kept apart, and so is "we do not know yet": the
 * status arrives from its own query, and a vehicle whose status has not landed would otherwise be
 * labelled as standing still — a claim nothing backs, on a page whose whole job is to say whether
 * a vehicle is reporting.
 *
 * `isError` is checked first and wins over everything else: a failed status query must show as
 * failed, not sit forever as "not known yet" — that reads as "still loading" when it never will.
 */
export function deviceActivity(
  status: DeviceStatusInfo | undefined,
  isError = false,
): DeviceActivity {
  if (isError) {
    return "error";
  }
  if (!status) {
    return "unknown";
  }
  if (!status.isDeviceCommunicating) {
    return "offline";
  }
  return status.isDriving ? "driving" : "stopped";
}
